module.exports = __webpack_public_path__ + "img/banner_es.3af3cc9b.jpg";